<h1 mat-dialog-title>{{data?.id ? 'Update' : 'Add'}} {{ data.type }}</h1>
<div mat-dialog-content>
  <form style="margin-top:6px" [formGroup]="typeForm" class="add-asset-form">
    <mat-form-field appearance="outline">
      <mat-label>Add Type</mat-label>
      <input type="text" matInput formControlName="type" pattern="^[a-zA-Z]([a-zA-Z0-9_ -\s]?)+$" cdkFocusInitial>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-flat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" class="btn-submit" (click)="submit()" [disabled]="typeForm.invalid || !isEdited"> {{data?.id ? 'Update' : 'Add'}} </button>
</div>